{
  "schemaVersion": "cogo.runtime-result-writes.v1",
  "description": "Every way a flow step can define an `_results.<name>` slot, derived from the @cogo/runtime-v2 sources. Consumed by actionflow-result-not-defined. Regenerate with `tsx packages/cogo-validator/scripts/build-runtime-result-writes.ts`.",
  "derivedFrom": [
    "packages/cogo-runtime-v2/src/action-flow-engine.ts",
    "packages/cogo-runtime-v2/src/*.ts"
  ],
  "derivedBy": "packages/cogo-validator/scripts/build-runtime-result-writes.ts",
  "paths": {
    "autoCapture": "engine writes `_results.${step.name}` when the handler returns non-undefined AND step.name is set",
    "explicitTarget": "the step names its own slot via one of `explicitTargetParams` below — derived from the engine's `read(<param>, \"target\")` and `stateTarget(<param>, ...)` declaration sites",
    "defaultSlot": "executor falls back to this literal when no target param is given",
    "unconditional": "written on a fixed path, independent of any param"
  },
  "counts": {
    "dispatchEntries": 68,
    "autoCapture": 5,
    "defaultSlots": 27,
    "unconditionalSlots": 2,
    "explicitTargetParams": 7,
    "unmappedDefaultSlots": 3
  },
  "autoCaptureActions": [
    "compute",
    "confirmAction",
    "datasource.call",
    "runMotion",
    "validate"
  ],
  "explicitTargetParams": [
    "name",
    "responseKey",
    "resultKey",
    "resultPath",
    "resultTarget",
    "statePrefix",
    "target"
  ],
  "defaultSlots": {
    "clipboardRead": "_results.clipboard",
    "cryptoAction": "_results.crypto",
    "csvExport": "_results.csvExport",
    "fileUpload": "_results.file",
    "geminiAction": "_results.gemini",
    "geminiStream": "_results.stream",
    "geolocation": "_results.geo",
    "graphqlAction": "_results.graphql",
    "invokeNativeSignatureAgent": "_results.nativeSignatureAgent",
    "jsonExport": "_results.jsonExport",
    "mediaCapture": "_results.media",
    "openAuthSession": "_results.auth",
    "payment": "_results.payment",
    "pickFiles": "_results.pickFiles",
    "supabaseAuth": "_results.auth",
    "supabaseRpc": "_results.rpc",
    "supabaseStorage": "_results.storage",
    "transactionAction": "_results.transaction",
    "wallet.create": "_results.wallet.create",
    "wallet.estimateFee": "_results.wallet.fee",
    "wallet.getBalance": "_results.wallet.balance",
    "wallet.getTxHistory": "_results.wallet.txHistory",
    "wallet.getTxStatus": "_results.wallet.txStatus",
    "wallet.list": "_results.wallet.list",
    "wallet.send": "_results.wallet.send",
    "wallet.syncBalance": "_results.wallet.syncBalance",
    "web3": "_results.web3"
  },
  "unconditionalSlots": [
    "_results.agentHistory",
    "_results.realtimePayload"
  ],
  "unmappedDefaultSlots": [
    {
      "file": "packages/cogo-runtime-v2/src/action-flow-engine.ts",
      "line": 3096,
      "slot": "_results.agent"
    },
    {
      "file": "packages/cogo-runtime-v2/src/action-flow-engine.ts",
      "line": 3136,
      "slot": "_results.vision"
    },
    {
      "file": "packages/cogo-runtime-v2/src/supabase-actions.ts",
      "line": 548,
      "slot": "_results.realtime"
    }
  ],
  "unmappedDispatchEntries": []
}
